import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ChartsModule } from 'ng2-charts';
import { ChartModule } from 'angular2-chartjs';
import 'hammerjs';
import 'chartjs-plugin-zoom';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material.module';
import { WelcomeComponent } from './welcome/welcome.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BasicComponent } from './shared/basic/basic.component';
import { HeaderDemoComponent } from './shared/header-demo/header-demo.component';

//import { PageNotFoundComponent } from './not-found.component';
import { CrudTableModule } from '../../lib/ng-crud-table';
import { DataTableModule } from '../../lib/ng-data-table';
import { TreeTableModule } from '../../lib/ng-tree-table';
import { DtToolbarModule } from '../../lib/dt-toolbar';
import { ModalModule } from '../../lib/modal';
import { ModalEditFormModule } from '../../lib/modal-edit-form';
import { TreeViewModule } from '../../lib/tree-view';
import { ContextMenuModule } from '../../lib/context-menu';
import { NotifyModule } from '../../lib/notify';
import { DateFormatPipe } from './shared/pipes/date-format.pipe';
import { DropdownSelectModule } from '../../lib/dropdown-select';
import { SelectListModule } from '../../lib/select-list';
import { InlineEditModule } from '../../lib/inline-edit';
import { NgxDtComponent } from './shared/ngx-dt/ngx-dt.component';
import { MatTableComponent } from './shared/mat-table/mat-table.component';
import { TabsModule } from '../../lib/tabs';
import { VertTabColorModule } from '../../lib/vert-tab-color';
import { FiltersTabsModule } from '../../lib/filters-tabs';
import { DropdownModule } from '../../lib/dropdown';

//import { WebviewerconfigModule } from './configuration/webviewerconfig';

//import { CallEventsService } from './shared/mat-table/services/call-events.service';
import { DataColsPipe, colSpecialCharsPipe } from './shared/pipes/data-cols.pipe';
import { CommonFilterService } from './shared/services/common-filter/common-filter.service';

import { AnalysisComponent } from './graphics/analysis/analysis.component';
import { CallProcessComponent } from './graphics/call-process/call-process.component';
import { NettestComponent } from './graphics/nettest/nettest.component';

import { PesqComponent } from './results/pesq/pesq.component';
import { PolqaComponent } from './results/polqa/polqa.component';
import { CallEventsComponent } from './results/call-events/call-events.component';
import { VbaComponent } from './results/vba/vba.component';
import { VacComponent } from './results/vac/vac.component';
import { EmuComponent } from './results/emu/emu.component';
import { FaxComponent } from './results/fax/fax.component';
import { AudioDelayComponent } from './results/audio-delay/audio-delay.component';
import { NettestrsltsComponent } from './results/nettestrslts/nettestrslts.component';
import { MobinforsltsComponent } from './results/mobinforslts/mobinforslts.component';
//https://stackoverflow.com/questions/40219666/global-pipe-in-angular-2

import { FiltersComponent } from './filters/filters.component';

import { NetworkStatusComponent } from './statistics/network-status/network-status.component';
import { VQUADComponent } from './statistics/network-status/vquad/vquad.component';
import { MobileComponent } from './statistics/network-status/mobile/mobile.component';
import { VQTComponent } from './statistics/network-status/vqt/vqt.component';
import { FileMonitorComponent } from './statistics/network-status/file-monitor/file-monitor.component';
import { CommandCenterComponent } from './statistics/network-status/command-center/command-center.component';
//import { TreedatatableComponent } from './shared/treedatatable/treedatatable.component';
import { VquadbtfxoComponent } from './statistics/network-status/vquadbtfxo/vquadbtfxo.component';
import { VquadscrparamsComponent } from './statistics/network-status/vquadscrparams/vquadscrparams.component';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';

import { ColorPickerModule } from 'ngx-color-picker';

import { PdfmakeModule } from 'pdfmake';
import { CommonFilterComponent } from './shared/components/common-filter/common-filter.component';
import { TitleComponent } from './shared/components/title/title.component';
import { DaterangepickerComponent } from './shared/components/daterangepicker/daterangepicker.component';
import { DaterangepickerDirective } from './shared/components/daterangepicker/daterangepicker.directive';
import { SynopsisComponent } from './shared/components/synopsis/synopsis.component';
import { DownloadFileComponent } from './shared/components/download-file/download-file.component';
import { UploadFileComponent } from './shared/components/upload-file/upload-file.component';
import { SubResultsSelectionComponent } from './shared/components/sub-results-selection/sub-results-selection.component';
import { NetworkStatusPipe, DualUTAPipe, DateAndTimeRangePipe } from './shared/pipes/network-status.pipe';
import { CustomReportComponent } from './output-results/custom-report/custom-report.component';

import { UrlReloadButtonComponent } from './shared/components/url-reload-button/url-reload-button.component';
import { ApiRecallButtonComponent } from './shared/components/api-recall-button/api-recall-button.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { TwoDigitDecimaNumberDirective } from './shared/directives/two-digit-decima-number.directive';
import { NumericDirective } from './shared/directives/numeric.directive';

import { LoadFilterComponent } from './shared/components/load-filter/load-filter.component';
import { UserInfoComponent } from './shared/components/user-info/user-info.component';
import { ScreenTopHeaderComponent } from './shared/components/screen-top-header/screen-top-header.component';
import { ScreenSecondHeaderComponent } from './shared/components/screen-second-header/screen-second-header.component';
import { ThreeSpinComponent } from './shared/components/spinners/three-spin/three-spin.component';
import { MagnifySpinComponent } from './shared/components/spinners/magnify-spin/magnify-spin.component';
import { BoldSpinComponent } from './shared/components/spinners/bold-spin/bold-spin.component';
import { LoadingSpinComponent } from './shared/components/spinners/loading-spin/loading-spin.component';
import { GoogleMapComponent } from './output-results/google-map/google-map.component';
import { AgmCoreModule } from '@agm/core';
import { GooglemaplegendpopupComponent } from './output-results/googlemaplegendpopup/googlemaplegendpopup.component';
import { AgmDirectionModule } from 'agm-direction';
//import { AgmMarkerSpiderModule } from 'agm-oms';
import { GooglemapstatuspopupComponent } from './output-results/googlemapstatuspopup/googlemapstatuspopup.component'; 
import { CustomGmapsMainComponent } from './output-results/custom-gmaps-main/custom-gmaps-main.component';
import { SchedulerStatusComponent } from './statistics/scheduler-status/scheduler-status.component';
import { LoginComponent } from './login/login.component';
import { LicenceCheckComponent } from './login/licence-check/licence-check.component';
import { LoginConfigComponent } from './login/login-config/login-config.component';
import { LogoutComponent } from './login/logout/logout.component';
//npm install @google/markerclustererplus @agm/js-marker-clusterer --save
//npm install -S js-marker-clusterer
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';

//import { } from 'googlemaps';
//import { GoogleMapsModule } from '@angular/google-maps'

import { AudioAndDelayStatisticsPieChartComponent } from './statistics/audio-and-delay-statistics-pie-chart/audio-and-delay-statistics-pie-chart.component';
import { VoiceQualityStatisticsPieChartComponent } from './statistics/voice-quality-statistics-pie-chart/voice-quality-statistics-pie-chart.component';

import { httpInterceptorProviders } from './http-interceptors';

import { CustomreportlinechartComponent } from './output-results/customreportlinechart/customreportlinechart.component';

import { MatTableExporterModule } from 'mat-table-exporter';

import { DatePipe } from '@angular/common';
import { LeafletGMapComponent } from './output-results/leaflet-gmap/leaflet-gmap.component';
//import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { TestJSGoogleMapComponent } from './output-results/test-jsgoogle-map/test-jsgoogle-map.component';
import { VMobileComponent } from './statistics/network-status/v-mobile/v-mobile.component';
import { VMobilescrparamsComponent } from './statistics/network-status/v-mobilescrparams/v-mobilescrparams.component';
import { ITSViewerComponent } from './output-results/itsviewer/itsviewer.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { HighlightPipe } from './shared/pipes/highlight.pipe';
import { ExploreOptionsComponent } from './shared/components/explore-options/explore-options.component';
import { ImagePopupModalsComponent } from './shared/components/explore-options/image-popup-modals/image-popup-modals.component';
import { AdvancedMarkersComponent } from './output-results/advanced-markers/advanced-markers.component';
import { AudioPlayerPopupComponent } from './output-results/audio-player-popup/audio-player-popup.component';

import { NgWaveformModule } from 'ng-waveform';


import { PdfViewerNg2Module } from 'src/app/popups/custom/pdf-viewer-ng2';
//import { PdfViewerNg2Component } from 'src/app/popups/custom/pdf-viewer-ng2/pdf-viewer-ng2.component';

import { LeafletModule } from '@asymmetrik/ngx-leaflet';

import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';


@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    DashboardComponent,

    BasicComponent,
    HeaderDemoComponent,

    NgxDtComponent,
    MatTableComponent,

    DateFormatPipe,
    DataColsPipe,
    colSpecialCharsPipe,

    AnalysisComponent,
    CallProcessComponent,
    NettestComponent,
    CommonFilterComponent,
    TitleComponent,
    
    DaterangepickerComponent,
    DaterangepickerDirective,
    PesqComponent,
    PolqaComponent,
    CallEventsComponent,
    VbaComponent,
    VacComponent,
    EmuComponent,
    FaxComponent,
    AudioDelayComponent,
    NettestrsltsComponent,
    MobinforsltsComponent,

    NetworkStatusComponent,
    VQUADComponent,
    MobileComponent,
    VQTComponent,
    FileMonitorComponent,
    CommandCenterComponent,
    //TreedatatableComponent,
    VquadbtfxoComponent,
    VquadscrparamsComponent,
    ConfirmDialogComponent,


    SynopsisComponent,
    DownloadFileComponent,
    UploadFileComponent,
    SubResultsSelectionComponent,
    FiltersComponent,
    NetworkStatusPipe,
    DualUTAPipe,
    DateAndTimeRangePipe,
    CustomReportComponent,
    UrlReloadButtonComponent,
    ApiRecallButtonComponent,

    TwoDigitDecimaNumberDirective,
    NumericDirective,
    LoadFilterComponent,
    UserInfoComponent,
    ScreenTopHeaderComponent,
    ScreenSecondHeaderComponent,
    ThreeSpinComponent,
    MagnifySpinComponent,
    BoldSpinComponent,
    LoadingSpinComponent,
    GoogleMapComponent,
    GooglemaplegendpopupComponent,
    GooglemapstatuspopupComponent,

    CustomGmapsMainComponent,
    SchedulerStatusComponent,
    LoginComponent,
    LicenceCheckComponent,
    LoginConfigComponent,
    LogoutComponent,
    AudioAndDelayStatisticsPieChartComponent,
    VoiceQualityStatisticsPieChartComponent,

    CustomreportlinechartComponent,

    LeafletGMapComponent,

    TestJSGoogleMapComponent,

    VMobileComponent,

    VMobilescrparamsComponent,

    ITSViewerComponent,

    ForgotPasswordComponent,

    HighlightPipe,
    ExploreOptionsComponent,
    ImagePopupModalsComponent,
    AdvancedMarkersComponent,

    AudioPlayerPopupComponent,

    //PdfViewerNg2Component,
  ],
  exports: [
    colSpecialCharsPipe,
    NetworkStatusPipe,
    DualUTAPipe,
    DateAndTimeRangePipe,
    HighlightPipe,
  ],
  imports: [
    BrowserModule,    
    AppRoutingModule,
    FlexLayoutModule,
    FormsModule,//Mat form field
    ReactiveFormsModule,//FormControl

    ChartsModule,
    ChartModule,

    BrowserAnimationsModule,
    MaterialModule,

    CrudTableModule,
    DataTableModule,
    TreeTableModule,
    DtToolbarModule,
    ModalModule,
    ModalEditFormModule,
    TreeViewModule,
    ContextMenuModule,
    NotifyModule,
    DropdownSelectModule,
    SelectListModule,
    InlineEditModule,
    TabsModule,
    VertTabColorModule,
    FiltersTabsModule,
    DropdownModule,
    BsDatepickerModule.forRoot(),
    //LeafletModule,
    //WebviewerconfigModule,

    //ColorPickerModule,
    NgWaveformModule,

    AgmCoreModule.forRoot({
      apiKey: 'YOUR_API_KEY',
      libraries: ['places', 'geometry'],//'drawing'
    }),
    AgmDirectionModule,
    //AgmMarkerSpiderModule,
    AgmJsMarkerClustererModule,

    MatTableExporterModule,

    PdfViewerNg2Module,

    LeafletModule,

    //https://medium.com/@zeeshankhan8838/mastering-web-service-workers-in-angular-a-comprehensive-guide-8a6ebad4ac29
    //https://blog.angular-university.io/angular-service-worker/
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production
    }),
    //...getServiceWorkerModule(), // Spread the result
  ],
  //https://stackoverflow.com/questions/69076213/how-to-do-empty-cache-and-hard-reload-from-js-in-angular
  providers: [CommonFilterService, httpInterceptorProviders, DatePipe],
  bootstrap: [AppComponent],
  entryComponents: [
    DaterangepickerComponent,
    VquadbtfxoComponent,
    VquadscrparamsComponent,
    VMobilescrparamsComponent,
    ConfirmDialogComponent,
    GooglemaplegendpopupComponent,
    GooglemapstatuspopupComponent,
    BasicComponent,
    AudioPlayerPopupComponent,
  ]
})
export class AppModule { }

//export function getServiceWorkerModule() {
//  return environment.production
//    ? ServiceWorkerModule.register('ngsw-worker.js', { enabled: true })
//    : [];
//}
